import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { JsonConvert } from 'json2typescript';
import { map, Observable } from 'rxjs';
import { UrlParams } from 'src/app/features/global/interfaces';

import { Reconciliation } from '@features/global/models';

@Injectable({ providedIn: 'root' })
export class ReconciliateIkpiService {
  private readonly http: HttpClient = inject(HttpClient);

  private readonly jsonConvert: JsonConvert = inject(JsonConvert);

  public reconciliate(urlParams: UrlParams): Observable<Reconciliation> {
    return this.http
      .get<Reconciliation>(
        `/rgg/guest-area-gs/v1/online-guestarea/${urlParams.numReservation}/reconciliate-ikpi`,
        {
          headers: { Media: '105' },
        },
      )
      .pipe(map((response) => this.jsonConvert.deserialize(response, Reconciliation)));
  }
}
